import IconButton from "components/blocks/IconButton";
import GridView from "components/GridView";
import { GridSchema, GridViewHeaderProps } from "components/GridView/GridView.types";
import RewardSettingsModal from "components/RewardsModals/RewardSettingsModal";
import RewardConfirmationModal from "components/RewardsModals/RewardConfirmationModal";
import { useCookieContext } from "contexts";
import { useBreadcrumb } from "contexts/breadcrumb/BreadcrumbContext";
import useGridData from "hooks/useGridData";
import useSystemDateTheme from "hooks/useSystemDateTheme";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {RewardResponse} from "../../../services/RewardsService/models";
import {getUserSession} from "../../../helpers/UserInfo";
import {SettingKeys} from "../../../services/settingService/models/SettingTypes";


type RewardConfirmationModalProps = {
    isOpen: boolean;
    data? : RewardResponse | undefined,
    name: string;
};

const ExaminersRewards = () => {
    const { t } = useTranslation("Examiners");
    const navigate = useNavigate();
    const { setBreadcrumbs } = useBreadcrumb();
    const { toSystemThemeDateFormat } = useSystemDateTheme();
    const { isAr } = useCookieContext();

    const [rewardConfirmationModalState, setRewardConfirmationModalState] = useState<RewardConfirmationModalProps>({
        isOpen: false,
        name: "",
    });

    const { loading, gridData, totalCount,fetchGridData, exportToExcel } = useGridData<"rewardsService", RewardResponse>(
        {
            service: "rewardsService",
            endpoint: "getAllExaminersRewards",
            exportExcelEndpoint: "exportExaminersRewardsToExcel",
            exportFileName: "examinersRewards",
            localizationNameSpace: "Examiners",
            defaultFilters:[
                     { field: "ExaminerId", value: getUserSession()?.id, operator: "equal" }
            ]
        },
    );

    useEffect(() => {
        setBreadcrumbs([
            {
                localizationKey: "examinerRewards",
                path: "/home/ExaminersRewards",
                menuItemId: "examinerRewards",
            },
        ]);
    }, []);

    const gridSchema = useMemo<GridSchema[]>(
        () => [
            // {
            //     field: "id",
            //     displayName: t("examinerName"),
            //     showOnMobile: true,
            //     sortable: true,
            //     filterable: true,
            //     render: (row: RewardResponse) => {
            //         return isAr ? row.user?.arabicName ??"" : row.user?.englishName ??"";
            //     },
            // },
            {
                field: "CourseOrder.SerialNumber",
                displayName: t("orderNumber"),
                sortable: true,
                filterable: true,
                render: (row: RewardResponse) => {
                    return (
                        // <button className="btn btn-link" onClick={() => navigate(`/home/orders/${row.courseOrderId}`)}>
                          <> {row.courseOrder.serialNumber}</>
                        // </button>
                    );
                },
            },
            {
                field: "researchCenter",
                displayName: t("researchCenter"),
                render: (row: RewardResponse) => {
                    return row?.courseOrder?.centreManagementDetail?.displayName;
                },
            },
            {
                field: "CourseOrder.AppliedUserId",
                filterable: false,
                sortable: true,
                filterOptions: {
                    type: "serverSideSelect",
                    serverSideSelectProps: {
                        label: t("applicantName"),
                        service: "accountService",
                        endpoint: "getUsersDropdown",
                        idValueKey: "id",
                        isPaginated: true,
                        textValueKey: isAr ? "arabicName" : "englishName",
                        useReactSelect: true,
                    }
                },
                displayName: t("applicantName"),
                render: (row: RewardResponse) => {
                    return isAr ? row?.courseOrder?.appliedUser?.arabicName ??""  : row?.courseOrder?.appliedUser?.englishName ??"";
                }
            },
            {
                field: "ApprovalDate",
                filterable: true,
                sortable: true,
                filterOptions: {
                    type: "date",
                },
                displayName: t("rewardApprovalDate"),
                render: (row: RewardResponse) => {
                    return toSystemThemeDateFormat(row.approvalDate);
                },
            },
            {
                field: "Value",
                filterable: true,
                sortable: true,
                displayName: t("rewardAmount"),
                render: (row: RewardResponse) => {
                    return `${row.value} ${t("Common:riyal")}`;
                },
            },
            {
                field: "RewardStatusId",
                displayName: t("Common:status"),
                showOnMobile: true,
                sortable: true,
                filterable: true,
                filterOptions: {
                 type: "serverSideSelect",
                    serverSideSelectProps: {
                        label: t("Common:status"),
                        service: "lookupService",
                        endpoint: "GetAllRewardStatusDropDown",
                        idValueKey:"id",
                        //isPaginated: true,
                        textValueKey:"details.0.displayName",
                      //  useReactSelect: true,
                    }
                },
                render(row: RewardResponse) {
                    return (
                        <span className={row?.rewardStatus?.styleCode}>
              {row?.rewardStatus?.details?.[0]?.displayName ??""}
            </span>
                    );
                },
            },
            {
                field: "id",
                displayName: t("Common:actions"),
                showOnMobile: true,
                render: (row: RewardResponse) => {

                    return (
                        <div  className={"d-flex gap-2"}>
                            {row?.fileId &&  <IconButton
                                title={t("paymentReceipt")}
                                icon="icon-receipt"
                                fitToIconWidth
                                innerIconColor="dark"
                                size="md"
                                onClick={() => {
                                    const downloadUrl = `/api/FileManager/DownloadFile/${row.fileId}`;
                                    let anchor = document.createElement("a");
                                    anchor.href = downloadUrl;
                                    anchor.target = "_blank";
                                    console.log(downloadUrl);
                                    anchor.download = `${row.file?.name}`?? t("paymentReceipt")
                                    anchor.click();

                                }}
                            />}
                        </div>
                    );
                },
            },



        ],
        [t, toSystemThemeDateFormat],
    );

    const viewHeader: GridViewHeaderProps = {
        title: t("examinersRewards"),
        singularName: t("Common:result"),
        totalCount: totalCount,
        onExportClick: exportToExcel
        // actionsComponent: <RewardSettingsModal settingKey={SettingKeys.ExaminerRewards}
        // />,
    };

    const onConfirmationModalOpen = (row: RewardResponse) => {
        setRewardConfirmationModalState({
            isOpen: true,
            data: row,
            name: (isAr ? row.user?.arabicName : row.user?.englishName) ?? "",
        });
    };

 
    return (
        <>
            <GridView
                loading={loading}
                gridProps={{
                    data: gridData ?? [],
                    gridSchema,
                }}
                 viewHeaderProps={viewHeader}
            />
        </>
    );
};

export default ExaminersRewards;
